<!-- Banner di impersonificazione -->
<div
  *ngIf="isImpersonated"
  class="flex flex-col lg:flex-row gap-4 items-center justify-center w-full p-3 bg-button-secondary text-button-secondary-text shadow-[0px_0px_1px_0px_rgba(0,0,0,0.04),0px_2px_6px_0px_rgba(0,0,0,0.04),0px_10px_20px_0px_rgba(0,0,0,0.04)]"
  role="banner"
>
  <!-- Messaggio di impersonificazione -->
  <span
    class="text-sm text-center leading-6"
    [innerHTML]="TRANSLATION_KEYS.admin.impersonate.RETURN_TO_ADMIN.BANNER_TITLE | translate:{name: impersonatedUserName}"
  ></span>

  <!-- Pulsante per terminare l'impersonificazione -->
  <ape-button
    [label]="TRANSLATION_KEYS.admin.impersonate.RETURN_TO_ADMIN.BUTTON_LABEL | translate"
    [ariaLabel]="TRANSLATION_KEYS.admin.impersonate.RETURN_TO_ADMIN.BUTTON_ARIA | translate"
    size="medium"
    [rounded]="true"
    [leftIcon]="'assets/icons/chevron-left.svg'"
    (click)="onEndImpersonation()"
  />
</div>
